import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useMemoCardContentIdsByCards = (cardIds: string[] | undefined) : string[] | undefined => {
  const memoCardContentDb = useSelector((state: RootState) => state.memoCardContentDb);
  if (cardIds === undefined) return;
  let ids: string[] = [];
  cardIds.forEach(cardId => {
    const itemIds = Object.keys(memoCardContentDb.memoCardContents).filter(id => memoCardContentDb.memoCardContents[id].cardId === cardId);
    ids.push(...itemIds);
  })
  return ids;
}

export default useMemoCardContentIdsByCards;
